import React from 'react';
import RDVButtonComponent from './RDVButtonComponent'

function NourrissonComponent (){
	return (
		<div id="nourrisson-section" className="article">
		  <h2>Ostéopathie du Nourrisson</h2>
			<div className="container">
      	<div className="row">
        	<div className="col-md-12">
						<div className="article-content">
							<p>
								La vie intra-utérine ainsi que l’accouchement peuvent être à l’origine de différentes contraintes.
								Des modifications, parfois visibles, peuvent entrainer l’apparition de troubles fonctionnels et ainsi
								perturber le développement et déséquilibrer l’état de santé du nourrisson.
							</p>

							<p>
								La délivrance lors de l’accouchement est parfois considérée comme un traumatisme pour l’enfant.
								Le temps de travail, l’utilisation d’instruments (tels que forceps, ventouse),
								la configuration du bassin de la mère (bassin étroit), l’utilisation de médicaments pour déclencher
								l’accouchement peuvent avoir une répercussion sur le bien être du nourrisson.
							</p>

							<p>
								De nombreux troubles avec ou sans liens apparents, sont le résultat de traumatismes ayant eu lieu
								lors de l’accouchement. Ils peuvent être corrigés par des séances d’ostéopathie
								entreprises suffisamment tôt.
							</p>

							<p>
								On retrouve parfois des enfants à tête plate ou avec une déformation postérieure du crâne
								( brachiocéphalie, plagiocéphalie ect..) ou des torticolis.
							</p>

							<p>
								On retrouve parfois des enfants à tête plate ou avec une déformation postérieure du crâne
								( brachiocéphalie, plagiocéphalie ect..) ou des torticolis.
							</p>

							<p>
								L’ostéopathe peut intervenir rapidement, avant les 5 premiers mois, sur ces troubles fonctionnels.
								La suture des os du crâne se faisant plus ou moins rapidement, l’ostéopathe agit par des méthodes
								très douces sur les tensions que le thorax et le crâne peuvent générer afin de diminuer l’aspect
								tête plate du nourrisson tout en préservant son bon développement.
							</p>

							<p>
								L’ostéopathie sur les bébés donnes des résultats rapides et étonnants.
							</p>

							<p>
								À partir de la naissance, le nourrisson peut présenter d’autres symptômes qui peuvent être améliorés
								par l’ostéopathie. Il est conseillé de consulter devant certains signes comme l’irritabilité,
								des tétées difficiles, reflux, troubles digestifs, troubles du sommeil, troubles posturaux.
							</p>

							<p>
								Grâce à des techniques douces et adaptées aux nourrissons, l’ostéopathe va libérer les tensions
								existantes afin d’harmoniser le corps du bébé et lui permettre une bonne croissance.
							</p>

							<p>
								Il est de ce fait recommandé d’emmener votre bébé chez l’ostéopathe dans les semaines suivant
								la naissance ainsi qu’à chaque stade de son développement (position assise, quatre-pattes, les
									premiers pas).
							</p>
						</div>
					</div>
				</div>
			</div>

			<h2>Quand consulter votre ostéopathe ?</h2>
			<div className="container">
      	<div className="row">
        	<div className="col-md-12">
						<div className="article-content">
							<p>
								Les différents symptômes, pouvant être traités par l’ostéopathe:
							</p>
							<ul>
								<li>
									<b>Déformation crânienne:</b> Ces déformations peuvent être dues aux instruments utilisés durant
									l’accouchement (spatules, ventouses, forceps.) ; un passage difficile du nourrisson dans
									le détroit inférieur du bassin de la maman ; un manque de mobilité de la tête en rotation
									droite ou gauche, ce qui entraine un aplatissement du crâne du côté de la position de confort.
								</li>
								<li>
									<b>Coliques du nourrisson:</b> Les coliques sont des douleurs abdominales, pouvant être
									dues à des problèmes de digestion du bébé, elles arrivent souvent entre les repas. Le bébé
									pleur, se tortille et il a beaucoup de gaz.
								</li>
								<li>
									<b>Régurgitations:</b> Ce sont des reflux gastriques plus ou moins importants, surtout
									pendant les premiers mois de la vie. Ils s’atténuent après l’âge de 6 mois.
									Ils peuvent être dus à une immaturité du système digestif, n’ayant aucunes incidences sur
									la courbe de poids ni sur l’appétit du bébé.
								</li>
								<li>
									<b>Torticolis du nourrisson:</b> C’est une difficulté à tourner la tête. Le bébé va se
									mettre dans une position de confort, en tournant plus souvent la tête d’un côté que de
									l’autre (en position couché, ou pendant la prise du biberon ou de la tétée).
									Cela peut être dû à des petites dysfonctions qui ont eu lieu lors de l’accouchement
									(accouchement difficile, long, avec spatule, ventouse, forceps.).
								</li>
								<li>
									<b>Troubles ORL chroniques du nourrisson:</b> Les troubles ORL, chez les nourrissons
									sont très fréquents jusqu’à l’âge de 3 ans. Ils sont gênants et douloureux pour le bébé.
									Quels sont-ils : rhume, otite, bronchite, bronchiolite.
								</li>
							</ul>

							<p>
								D’autres motifs fréquents et qui peuvent être traités par l’ostéopathe:
							</p>
							<ul>
								<li>
									Si votre bébé présente un strabisme.
								</li>
								<li>
									Si votre bébé est hypernerveux, pleur souvent, dort peu.
								</li>
								<li>
									Afin de faciliter le travail de l’ostéopathe, il vous sera demandé d’apporter avec vous
									le carnet de santé de votre bébé.
								</li>
							</ul>
						</div>

					</div>
				</div>
			</div>

			<RDVButtonComponent/>

	  </div>
	)
}

export default NourrissonComponent;
